'use strict';

var base = require('./base');

require('jquery-slimscroll');

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
 function getOptions($productContainer, defaultOptions) {
    var options = [];
    if (defaultOptions) {
        var options = $productContainer
        .find('.diet-product-default-options .product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            var pid = $elOption.find('option[value="' + urlValue + '"]').data('pid');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId.toString(),
                pid: pid,
                qty: $(this).data('qty').toString()
            };
        }).toArray();

    } else {
        $productContainer
        .find('.diet-customize .product-option')
        .each(function () {
            var optionid = $(this).data('option-id');
            $(this).find('[data-selected]').each(function() {
                if ($(this).data('selected')) {
                    var selectedValueId = $(this).data('value-id');
                    var pid = $(this).find('.product').data('pid');
                    var qty = $(this).find('.product .quantity-select').val();
                    options.push({
                        optionId: optionid,
                        selectedValueId: selectedValueId ? selectedValueId.toString() : '',
                        pid: pid,
                        qty: qty
                    });
                }
            });
        });

        var kitOption = $productContainer.find('[data-option-id="kitProduct"] .options-select option:selected');
        if (kitOption) {
            options.push({
                optionId: kitOption.closest('.product-option').data('option-id'),
                selectedValueId: kitOption.data('value-id').toString(),
                pid: kitOption.data('pid'),
                qty: kitOption.closest('.product-option').data('qty')
            });
        }
    }

    return JSON.stringify(options);
}

var dietDetail = {
    dietAddToCart: function () {
        $(document).on('click', 'button.diet-add-to-cart, a.add-to-cart-customize-default', function (e) {
            e.preventDefault()
            var addToCartUrl;
            var pid;
            var dietPids;

            var $productContainer = $(this).closest('.product-detail');
            pid = $(this).closest('.product-detail').data('pid');

            addToCartUrl = $('.add-to-cart-url').val();
            var form = {
                pid: pid,
                quantity: 1
            };
            form.options = $(this).hasClass('add-to-cart-customize-default') ? getOptions($productContainer, true) : getOptions($productContainer, false);

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.error) {
                            $('.diet-add-to-cart-error').html('<div class="alert alert-danger text-center">' + data.message + '</div>');
                            setTimeout(function(){
                                $('.diet-add-to-cart-error').empty();
                            }, 5000);
                        } else {
                            window.location.href = $('.diet-customize').data('url');
                        }
                    }
                });
            }
        });
    },

    attributeToggle: function() {
        $('body').on('click', '.attribute-dropdown .attribute-dropdown-select', function () {
            $(this).siblings('.attribute-dropdown-list').toggleClass('active');
            $(this).toggleClass('active');
        });
        $('body').on('click', function (e) {
            if (!$(e.target).closest('.attribute-dropdown').length && $('.attribute-dropdown-list.active').length) {
                $('.attribute-dropdown .attribute-dropdown-select').removeClass('active');
                $('.attribute-dropdown .attribute-dropdown-list').removeClass('active');
            }
        });
    },

    productAccordion: function () {
        $('#product-accordion').on('shown.bs.collapse', function () {
            $("body").trigger("init:diet-timings-carousel");
        });
    },

    dietQuickView: function () {
        $('body').on('click', '.quickview-diet', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $('#dietQuickView .modal-body').empty();
            $.ajax({
                url: url,
                dataType: 'HTML',
                type: 'get',
                success: function (response) {
                    $('#dietQuickView .modal-body').html(response);
                    $('#dietQuickView').modal('show');
                }
            })
        });
    },

    intiateQuickViewImageSlick: function () {
        $('body').on('shown.bs.modal', '#dietQuickView', function () {
            base.quickViewImagesSlick();
        });
    }
};

module.exports = dietDetail;
